import { styled, Box } from "@mui/material";

export const SliderWrapper = styled(Box)({
    maxWidth: "250px",
    width: "250px",
});
